import React from "react";
import JsonIcon from "../../../../images/json.svg";

const buildLink = (url) => {
  const split = url.split("/");
  const link = `${process.env["REACT_APP_API_BASE"]}/admin/${split[3]}/json/${split[5]}`;
  return link.replace(".xml", ".json");
};

const JsonLink = () => {
  let url = buildLink(window.location.href);
  return (
    <div>
      <button type="button" className="btn btn-link">
        <a href={url} target="_blank" rel="noopener noreferrer">
          Raw JSON&nbsp;
          <img src={JsonIcon} className="icon" alt="json icon" />
        </a>
      </button>
      <div>
        <small id="jsonHelpTxt" class="text-muted font-italic">
          *Json is auto-generated from the original XML file. The conversion is
          not exact and data may be malformed.
        </small>
      </div>
    </div>
  );
};

export default JsonLink;
